import React, { useCallback, useEffect, useRef, useState } from 'react';

import './style.scss';

const delta = 150;
const startDelta = 130;

const PullToReload = () => {
  const touchStartY = useRef(0);
  const [visible, setVisible] = useState(false);
  const handleTouchStart = (e) => {
    touchStartY.current = e.touches[0].clientY < startDelta
      ? e.touches[0].clientY
      : 0;
  };
  const handleTouchMove = useCallback((e) => {
    if (!touchStartY.current) return;

    const touchY = e.touches[0].clientY;
    const touchDiff = touchY - touchStartY.current;
    if (touchDiff > delta && window.scrollY === 0) {
      setVisible(true);
      e.preventDefault();
    } else if (touchDiff < delta && visible) {
      setVisible(false);
      e.preventDefault();
    }
  }, [visible]);

  const handleTouchEnd = useCallback(() => {
    if (!visible) return;

    setVisible(false);
    window.location.reload();
  }, [visible]);

  useEffect(() => {
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchMove]);

  return (
    <div className={`pull-to-refresh ${visible ? 'visible' : ''}`}>
      <i className="icon-refresh" />
    </div>
  );
};

export default PullToReload;
